const flatpickr = require('flatpickr');

import Chart from 'chart.js/auto';
window.ChartJS = Chart;
